

// import React from "react";
// import { Doughnut } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// ChartJS.register(ArcElement, Tooltip, Legend);

// const Project = () => {
//   const { data, loading } = UseGetDashBoardDataPro(`/Dashboard/projects`);

//   const data = {
//     labels: ["yet to start","In-Progress",  "On-Hold"],
//     datasets: [
//       {
//         data: [5, 10, 5],
//         backgroundColor: ["#007bff", "#28a745",  "#ff4500"],
//         hoverBackgroundColor: ["#0056b3", "#218838", "#ff2400"],
//       },
//     ],
//   };

//   return (
//     <div className="bg-white p-4 rounded-lg drop-shadow-lg h-[45vh]  2xl:h-[35vh] w-full">
//       <div className="flex justify-around items-center h-[50%]">
//       <div className=" items-center justify-center ">
//         <h2 className="text-sm font-semibold text-[#4F4768] mb-4">Projects</h2>
//         <span className="text-3xl font-bold text-indigo-600">25</span>
//       </div>
//       <div className='border-r border-[1px] border-slate-200/60 border-solid'/>

//       <div className="flex w-[30%]">
//       <Doughnut
//   data={data}
//   options={{
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         display: false, 
//       },
//     },
//   }}
//   // width={200} 
//   // height={200} 
// />

//      </div>
//       </div>
//       <div className="grid grid-cols-2 gap-3 h-[50%]">
//         <div className="flex justify-between items-center p-1 bg-blue-100 rounded">
//           <span className="text-xs font-normal text-[#4F4768]">yet to start</span>
//           <span className="text-blue-600 font-medium">5</span>
//         </div>
       
//         <div className="flex justify-between items-center p-1 bg-red-100 rounded">
//           <span className="text-xs font-normal text-[#4F4768]">On-Hold</span>
//           <span className="text-red-600 font-medium">5</span>
//         </div>
//         <div className="flex justify-between items-center p-1 bg-green-100 rounded">
//           <span className="text-xs font-normal text-[#4F4768]">In-Progress</span>
//           <span className="text-green-600 font-medium">10</span>
//         </div>
//         {/* <div className="flex justify-between items-center p-1 bg-orange-100 rounded">
//           <span className="text-xs font-normal text-[#4F4768]">Canceled</span>
//           <span className="text-orange-600 font-medium">5</span>
//         </div> */}
//       </div>
//     </div>
//   );
// };

// export default Project;


import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import UseGetDashBoardDataPro from "../../../../Components/Hooks/UseGetDashBoardDataPro";

ChartJS.register(ArcElement, Tooltip, Legend);

const Project = () => {
  const { data, loading } = UseGetDashBoardDataPro(`/Dashboard/projects`);

    const projectCounts = data?.category_wise_counts || {
    completed: 0,
    in_progress: 0,
    on_hold: 0,
    yet_to_start: 0,
  };

  const chartData = {
    labels: ["Yet to Start", "In Progress", "On Hold", "Completed"],
    datasets: [
      {
        data: [
          projectCounts.yet_to_start,
          projectCounts.in_progress,
          projectCounts.on_hold,
          projectCounts.completed,
        ],
        backgroundColor: ["#007bff", "#28a745", "#ff4500", "#ffcc00"],
        hoverBackgroundColor: ["#0056b3", "#218838", "#ff2400", "#e6b800"],
      },
    ],
  };

  return (
    <div className="bg-white p-4 rounded-lg drop-shadow-lg h-[45vh] 2xl:h-[35vh] w-full">
      {/* {loading ? (
        <div className="flex justify-center items-center h-full">
          <span className="text-gray-500 text-sm">Loading...</span>
        </div>
      ) : (
        <> */}
          <div className="flex justify-around items-center h-[50%]">
            <div className="text-center">
              <h2 className="text-sm font-semibold text-[#4F4768] mb-4">Projects</h2>
              <span className="text-3xl font-bold text-indigo-600">
                {Object.values(projectCounts).reduce((acc, val) => acc + val, 0)}
              </span>
            </div>
            <div className="border-r border-slate-200/60 border-solid h-full"></div>
            <div className="flex w-[30%]">
              <Doughnut
                data={chartData}
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      display: false,
                    },
                  },
                }}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 h-[50%]">
            <div className="flex justify-between items-center px-3 bg-blue-100 rounded">
              <span className="text-xs font-normal text-[#4F4768]">Yet to Start</span>
              <span className="text-blue-600 font-medium">{projectCounts.yet_to_start}</span>
            </div>

            <div className="flex justify-between items-center px-3 bg-green-100 rounded">
              <span className="text-xs font-normal text-[#4F4768]">In Progress</span>
              <span className="text-green-600 font-medium">{projectCounts.in_progress}</span>
            </div>

            <div className="flex justify-between items-center px-3 bg-red-100 rounded">
              <span className="text-xs font-normal text-[#4F4768]">On Hold</span>
              <span className="text-red-600 font-medium">{projectCounts.on_hold}</span>
            </div>

            <div className="flex justify-between items-center px-3 bg-yellow-100 rounded">
              <span className="text-xs font-normal text-[#4F4768]">Completed</span>
              <span className="text-yellow-600 font-medium">{projectCounts.completed}</span>
            </div>
          </div>
        {/* </>
      )} */}
    </div>
  );
};

export default Project;
